import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import queryString from 'query-string'

import { useInitApp } from 'aem-libs-react-ts/src/hooks/useInitApp'
import { IContext } from 'aem-libs-react-ts/src/store/Store'
import { amountInitResponse, savingsInitResponse } from 'aem-libs-regular-investment/src/utils/initData'

import './App.scss'

import { initAmountCalc, initSavingsCalc, setCalcTab } from './actions/actionCreators'
import { AppContainer } from './AppContainer'
import { getInitData } from './initData'
import { IStaticParams } from './model'
import { contextSelector } from './store/selectors'
import { IQueryParams } from './model/IQueryParams'
import { parseTabFromString } from './utils/investmentUtils'

const App = () => {
  const queryParams = queryString.parse(location.search) as IQueryParams

  const {
    paramsStatic: { defaultCalc, amountCalc, savingsCalc }
  }: IContext<{}, IStaticParams> = useSelector(contextSelector)

  const dispatch = useDispatch()

  const initData = () => {
    const finalTab = queryParams.tab ? parseTabFromString(queryParams.tab, defaultCalc) : defaultCalc

    const data = getInitData(amountCalc, savingsCalc, queryParams, finalTab)

    dispatch(initAmountCalc(data.amountValues, amountInitResponse))
    dispatch(initSavingsCalc(data.savingsValues, savingsInitResponse))
    dispatch(setCalcTab(finalTab))
  }

  const AppComponent = useInitApp(AppContainer, initData)

  return <AppComponent />
}

export default App
